import { Component, OnInit, ElementRef, ViewChild, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";

@Component({
  selector: '[mft-cards-nav]',
  templateUrl: './managedcards.navigation.component.html'
})
export class ManagedCardsNavigationComponent implements OnInit {
  @Input() managedCardsName: string;

  constructor(public headerAndNavigationService: HeaderAndNavigationService
  ) { }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/managecards/managedcards.navigation.component.ts